import { Injectable } from '@angular/core';

import { Resource, ResourceService } from './resource';

export class User extends Resource {
  gid: string;
  name: string;
  email: string;
}

@Injectable({ providedIn: 'root' })
export class Users extends ResourceService<User> {
  private _currentUser: User;

  constructor() {
    super();

    this.base = 'users';
    this.ctor = User;
  }

  currentUser(): User {
    if (this._currentUser) {
      return this._currentUser;
    }
    this._currentUser = this.$findOne('current');
    return this._currentUser;
  }
}
